export function updateUserRedirect(message) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_USER_REDIRECT',
                payload: message
            });
            resolve(true)
        });
    }
};

export function resetUserRedirect() {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'RESET_USER_REDIRECT'
            });
            resolve(true)
        });
    }
};